import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  sidebar: ReactNode;
}

export function VaultShell({ children, sidebar }: Props) {
  return (
    <div className="vault-shell">
      <aside className="vault-shell__sidebar">{sidebar}</aside>
      <main className="vault-shell__main">{children}</main>
    </div>
  );
}
